import CurrencyCell from 'components/CustomGridCell/CurrencyCell';
import { AdjustmentType } from 'enums';
import { AdjustmentCategoryGridProps } from 'types';

const props: AdjustmentCategoryGridProps = {
    category: AdjustmentType.Discount,
    adjustmentTypes: [AdjustmentType.Discount],
    title: 'Discounts',
    dataItemKey: 'rowNumber', //'voucherId', voucherId is not unique on DeductionsPage, so use rowNumber
    selectMode: 'multiple',
    selectionGroupField: 'invoiceId',
    selectionGroupTitle: 'Invoice Number',
    gridColumns: [
        {
            field: 'invoiceId',
            title: 'Invoice Number',
            filterTitle: 'text'
        },
        {
            field: 'invoiceDate',
            title: 'Invoice Date',
            format: '{0:MMMM d, yyyy}',
            filterTitle: 'date'
        },
        {
            field: 'voucherPoId',
            title: 'PO Number',
            filterTitle: 'text'
        },
        {
            field: 'discountPaymentAmount',
            title: 'Amount',
            cell: CurrencyCell,
            filterTitle: 'numeric'
        }
    ]
}
export default props;
